import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-advance-options',
    templateUrl: './advance-options.component.html',
    styleUrls: ['./advance-options.component.scss'],
    standalone: false,
})
export class AdvanceOptionsComponent {
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';
    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        if (this.dataService?.calculationData?.input?.recordId?.pipeScheduleId) {
            this.form.get('enableAdvOp').setValue(true);
        } else {
            this.form.get('enableAdvOp').setValue(false);
        }
    }
}
